'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { useMemo } from 'react';
import { allowedCommissionTypes } from 'pages/finance/commission/commission/CommissionEnums';
import AgreementCommissionStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/AgreementCommissionStageSteps';
import { TaskModalPageProps } from '../TaskModalPageProps';
import TaskModalStepToggle from '../TaskModalStepToggle';

const NswAgreementComplianceTypePage = ({
  task,
  toggleTaskStep,
  commissionDetails,
  currentCommissionInfo,
  onCommissionUpdated,
  registerTaskModalPageValidation,
}: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps]);
  const commissionStep = taskSteps[0];
  const remunerationStep = taskSteps[1];

  if (!commissionStep || !remunerationStep || !onCommissionUpdated) {
    return null;
  }

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step2title" color="var(--text-primary)">
        Step 2: Confirm Commission
      </AgxTypography>
      <AgreementCommissionStageSteps
        commissionDetails={commissionDetails}
        onCommissionUpdated={onCommissionUpdated}
        allowedCommissionTypes={allowedCommissionTypes}
        currentCommissionInfo={currentCommissionInfo}
        commissionStep={commissionStep}
        updateCommissionTaskStep={(isCompleted) =>
          toggleTaskStep(commissionStep.order ?? 0, isCompleted)
        }
        registerTaskModalPageValidation={registerTaskModalPageValidation}
      />
      <TaskModalStepToggle step={remunerationStep} toggleTaskStep={toggleTaskStep} />
    </AgxSpacer>
  );
};

export default NswAgreementComplianceTypePage;
